import { useContext, useEffect, useState } from "react"
import { MdContentCopy, MdDelete, MdDownload, MdLibraryAdd, MdLock, MdLockOpen, MdMail, MdSearch } from "react-icons/md"
import { useNavigate, useParams } from "react-router-dom"
import UserContext from "../../Context/UserContext"
import Modal from "../../Components/Modal"
import { checkInvite, deleteInviteDoc, disableUserAccount, getEventsDoc, getEventsDocWhereDate, getExhibitorPendingInvitesDoc, getExhibitorsDoc, getInviteDoc, newExhibitorInvite, updateUserDoc } from "../../Requests/firebaseFirestore"
import { utils, write } from "xlsx"
import { saveAs } from "file-saver"
import { sendExhibitorInvite } from "../../Requests/sendMail"
import Spinner from "../../Components/Spinner"

export default function ExhibitorsPage() {
  const [loading, setLoading] = useState(true)
  const [event, setEvent] = useState('')
  const [exhibitorModal, setExhibitorModal] = useState(false)
  const {user, url} = useContext(UserContext)
  const initialExhibitorValue = {
    company:'',
    email:'',
    event:''
  }
  const [newExhibitor, setNewExhibitor] = useState(initialExhibitorValue)
  const [exhibitors, setExhibitors] = useState([])
  const [exhibitorList, setExhibitorList] = useState([])
  const [search, setSearch] = useState({name:'', event:''})
  const {role} = useParams()
  const [alert, setAlert] = useState('')
  const [events, setEvents] =useState([])
  const [invitesModal, setInvitesModal] = useState(false)
  const navigate = useNavigate()
  const [invites, setInvites] = useState([])

  const reloadExhibitorList = async (exhibitors) =>{
    setLoading(true)
    let exhs
    if(exhibitors){
      setExhibitorList(exhibitors)
    }else{
      exhs = await getExhibitorsDoc()
      setExhibitors(exhs)
      let filteredList = []
      exhs.forEach((exhibitor)=>{
        let evnts = exhibitor.events.map(evnt=>evnt.id)
        if((exhibitor.fullName.toLowerCase().includes(search.name.toLowerCase())||exhibitor.company.toLowerCase().includes(search.name.toLowerCase()))&&(evnts.includes(search.event)||search.event==='')){
          filteredList = [...filteredList, exhibitor]
        }
      })
      setExhibitorList(filteredList)
      
    }
    setLoading(false)
  }

  const getEvents = async() => {
    const res = await getEventsDoc()
    setEvents([...res])
  }

  useEffect(()=>{
    if(user!=='checking'){
      if(role !== 'organizer'){
        navigate(`/${role}`)
      }else{
        reloadExhibitorList()
        getEvents()
      }
      setLoading(false)
    }
  },[user, role, navigate])

  const handleModal = async () =>{
    setAlert('')
    if(events.length === 0){
      const res = await getEventsDocWhereDate()
      setEvents(res)
    }
    setExhibitorModal(!exhibitorModal)
  }

  const handleInputChange = (e) => {
    setAlert('')

    const {name, value} = e.target
    setNewExhibitor({...newExhibitor,[name]: value})
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const check = await checkInvite(newExhibitor.email, newExhibitor.event)
    if(check){
      setAlert('Ya se ha enviado una invitación')
    }else{
      setAlert('')
      setNewExhibitor(initialExhibitorValue)
      setExhibitorModal(false)
      let event = {}
      events.forEach((e)=>{
        if(e.id===newExhibitor.event){
          event = e
        }
      })
      const inviteId = await newExhibitorInvite({...newExhibitor, event:{id:event.id, name:event.name}})
      const send = await sendExhibitorInvite({...newExhibitor,event:event ,invite: inviteId})
      if(send.status==='failed'){
        await deleteInviteDoc(inviteId)
      }
    }
  }

  const handleSearch = async (e) => {
    if (e){
      e.preventDefault()
    }
    setEvent(search.event)
    let filteredList = []
    exhibitors.forEach((exhibitor)=>{
      let evnts = exhibitor.events.map(evnt=>evnt.id)
      if((exhibitor.fullName.toLowerCase().includes(search.name.toLowerCase())||exhibitor.company.toLowerCase().includes(search.name.toLowerCase()))&&(evnts.includes(search.event)||search.event==='')){
        filteredList = [...filteredList, exhibitor]
      }
    })
    reloadExhibitorList(filteredList)
  }

  const handleDisable = async (id, state) =>{
    await disableUserAccount(id, state)
    reloadExhibitorList()
  }

    const handleDownload = () => {
      let toXls = []
      exhibitorList.forEach((exhibitor)=>{
        let events = exhibitor.events.map(ev => ev.name)
        toXls = [...toXls, {'Nombre copmpleto':exhibitor.fullName, 'Empresa':exhibitor.company,'Email':exhibitor.email, 'Eventos':events.join(', ')}]
      })
  
      const ws = utils.json_to_sheet(toXls)
      const wb = {
        Sheets:{
          'data':ws
        },
        SheetNames:['data']
      }
      const eb = write(wb,{bookType:'xlsx',type:'array'})
      const data = new Blob([eb],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UFT-8'})
      saveAs(data, 'ChannelTalks-expositores.xlsx')
    }

    const handleInvitesModal = async () => {
      if(!invitesModal){
        const res = await getExhibitorPendingInvitesDoc()
        setInvites(res)
      }
      setInvitesModal(!invitesModal)
    }

    const handleDeleteInvite = async (inviteId) => {
      const res = await getInviteDoc(inviteId)
      if(res.status === 'pending'){
        await deleteInviteDoc(inviteId)
      }
      handleInvitesModal()
    }

    const handleCopy = (text) => {
      navigator.clipboard.writeText(text)
    }

    const handleDeleteExh = async (exh) => {
       await updateUserDoc(exh.id, {
         events : exh.events.filter((e)=>{return e.id!==search.event})
       })
       reloadExhibitorList()
    }

  return(<>
    {loading
    ?
    <div className="text-black py-5">
      <Spinner/>
    </div>
    :
    <>
    <div className="container mx-auto px-4">
      <div className="flex justify-between my-4">
        <h1 className="text-stone-600 font-semibold text-xl py-2">Expositores</h1>
        <button onClick={handleInvitesModal} className="action-btn"><MdMail size={25}/>Invitaciones</button>
      </div>
      <div className="table-holder">
    <table className="w-full min-w-[650px]">
      <thead>
        <tr>
          <th colSpan='100%'>
            <div className="px-5 w-full flex items-center justify-between">
              <div className="flex gap-2">
                <button className="light-button" onClick={()=>{handleModal()}}><MdLibraryAdd size={25}/></button>
                <form onSubmit={handleSearch} className=" font-normal text-black flex gap-2" >
                  <input type='text' className=" font-normal text-black" placeholder='Nombre o empresa' onChange={(e)=>{setSearch({...search, name:e.target.value})}} value={search.name}/>
                  <select name="" id="" value={search.event} onChange={(e)=>{setSearch({...search, event:e.target.value})}}>
                    <option value="" >Todos los eventos</option>
                    {events.map((event, index)=>{return(
                      <option value={event.id} key={index}>{event.name}</option>
                    )})}
                  </select>
                  <button className="light-button"><MdSearch size={25}/></button>
                </form>
              </div>
              <button className="light-button flex gap-1" onClick={handleDownload}>
                <MdDownload size={25}/>Descargar
              </button>
            </div>
          </th>
        </tr>
        <tr>
          <th className="w-52"><h1>Acciones</h1></th>
          <th><h1>Nombre</h1></th>
          <th><h1>Empresa</h1></th>
          <th><h1>Eventos</h1></th>
        </tr>
      </thead>
      <tbody>
        {exhibitorList.length>0?
        <>
          {exhibitorList.map((exhibitor, index)=>{return(
            <tr key={index}>
              <td className="flex justify-center gap-2">
                {event !== ''?
                <button className="action-button border-red-500 text-red-500 hover:text-white hover:bg-red-500 active:bg-red-700 duration-150" onClick={()=>{handleDeleteExh(exhibitor)}}><MdDelete size={25}/></button>
                :''}
                <button className="action-button border-stone-500 text-stone-500 hover:text-white hover:bg-stone-500 active:bg-stone-700 duration-150" onClick={()=>{handleDisable(exhibitor.id, exhibitor.inactive)}}>{exhibitor.inactive?<MdLock size={25}/>:<MdLockOpen size={25}/>}</button>
              </td>
              <td>{exhibitor.fullName}{exhibitor.inactive?' (Inactivo)':''}</td>
              <td>{exhibitor.company}</td>
              <td>
                <div className="flex flex-col">
                  {exhibitor.events.map((event, index)=>{return(<span key={index}>{event.name}</span>)})}
                </div>
              </td>
            </tr>
          )})}
        </>
        :
        <tr>
          <td colSpan='100%'>No se encontraron Expositores</td>
        </tr>
        }
      </tbody>
    </table>

      </div>
    </div>
    <Modal isActive={exhibitorModal} handle={handleModal} title='Nuevo expositor'>
      <form className='flex flex-col gap-4' onSubmit={handleSubmit}>
        <div className="input-holder w-[75%]">
          <input type='text' name="company" id="new-exhibitor-company" onChange={handleInputChange} value={newExhibitor.company} required></input>
          <label htmlFor="new-exhibitor-name">Nombre de la empresa</label>
        </div>
        <div className="input-holder w-[75%]">
          <input type='email' name="email" id="new-exhibitor-email" onChange={handleInputChange} value={newExhibitor.email} required></input>
          <label htmlFor="new-exhibitor-email">Email</label>
        </div>
        <div className="input-holder w-[75%]">
          <select name="event" id="new-exhibitor-event" value={newExhibitor.event} onChange={handleInputChange} required>
            <option value="" disabled hidden></option>
            {events.map((event, index)=>{
              return(<option key={index} value={event.id}>{event.name} {event.date}</option>)
            })}
          </select>
            <label htmlFor="new-exhibitor-event">Evento</label>
        </div>
        {alert===''?<></>:
        <span className="text-red-500 text-center">{alert}</span>
        }
        <button className="send-btn">Enviar</button>
      </form>
    </Modal>
    <Modal isActive={invitesModal} handle={handleInvitesModal} title='Invitaciones pendientes' size='lg'>
        <div className="w-[90%] mx-auto">
          <div className="table-holder">
            <table className="w-full min-w-[500px]">
              <tbody>
                <tr className="bg-[#F03623] text-white font-semibold">
                  <td className="px-4">
                    <span>Acción</span>
                  </td>
                  <td>
                    <span>Enviado a</span>
                  </td>
                  <td>
                    Evento
                  </td>
                </tr>
                {invites.map((invite, index)=>{return(
                  <tr key={index}>
                    <td>
                      {invite.status==='pending'?<div className="flex gap-1">
                      <button className="action-button border-red-500 text-red-500 hover:text-white hover:bg-red-500 active:bg-red-700 duration-150" onClick={()=>{handleDeleteInvite(invite.id)}}><MdDelete size={25}/></button>
                      <button className="action-button border-blue-500 text-blue-500 hover:text-white hover:bg-blue-500 active:bg-blue-700 duration-150" onClick={()=>{handleCopy(`${url}/newuser/exhibitor/${invite.id}`)}}><MdContentCopy size={25}/></button>
                      </div>:<>-</>}
                    </td>
                    <td className="col-span-2 justify-self-start">{invite.email}</td>
                    <td>{invite.event.name}</td>
                  </tr>
                )})}
                
              </tbody>
            </table>
          </div>
        </div>
    </Modal>
    </>
    }
  </>
  )
}